export const UPDATE_LOADER = "loader/UPDATE_LOADER";
export const RESET_LOADER = "loader/RESET_LOADER";
export const SHOW_LOADER = "loader/SHOW_LOADER";
export const HIDE_LOADER = "loader/HIDE_LOADER";
